// Editable takeaways data - Skill Playbook content per competency

export interface CompetencyTakeaway {
  icon: string;
  coreIdea: string;
  keyMoves: string[];
  guidingQuestion: string;
}

export const takeawaysPageConfig = {
  sectionLabel: "Complete Skill Playbook",
  title: "Key Takeaways",
  subtitle: "The all-in-one quick-reference guide for each skill. Use it to navigate key conversations at work.",
};

export const takeawaysData: Record<string, CompetencyTakeaway> = {
  "Goal Setting": {
    icon: "🎯",
    coreIdea: "Start with the result, then make progress measurable, then make it repeatable.",
    keyMoves: [
      "Set one team outcome first",
      "Define observable success",
      "Choose 1–2 performance targets",
      "Build repeatable daily/weekly habits",
      'Make "better" measurable, avoid overload',
      "Treat problems as goal-review signals",
    ],
    guidingQuestion: "What changes, how will we measure it, what will we do daily?",
  },
  Delegation: {
    icon: "📋",
    coreIdea: "Strong delegation builds ownership and decision-making skills, not just task completion.",
    keyMoves: [
      'Define "done": outcome, scope, constraints',
      "Match task to skills and growth",
      "Name one clear owner, and share decision rules",
      "Set timelines and milestones",
      "Monitor progress at agreed checkpoints",
      "Reinforce behaviour with feedback",
    ],
    guidingQuestion: "Who owns the result, what does ‘done’ look like, by when?",
  },
  "Giving Feedback": {
    icon: "💬",
    coreIdea: "Keep feedback factual, impact-linked and forward-moving.",
    keyMoves: [
      "Start with the facts you observed",
      "Stay respectful, avoid labels or assumptions",
      "Link behaviour to larger impact",
      "Don't delay or jump to fixes",
      "Suggest next steps and offer support",
      "Co-create steps with shared ownership where possible",
    ],
    guidingQuestion: "What happened, why it matters, what needs to change?",
  },
  "Conflict Management": {
    icon: "⚔️",
    coreIdea: "Flex your style to the moment while protecting results and relationships.",
    keyMoves: [
      "Choose a style consciously",
      "Compete when stakes are high and time is short",
      "Collaborate for the best long-term outcome",
      "Compromise to keep progress moving when speed matters",
      "Pause when emotions are high or facts are unclear",
      "Accommodate to protect harmony and relationships",
    ],
    guidingQuestion: "What's the right balance of results and relationships for this situation?",
  },
};
